import { action, observable } from "mobx";

import MainEntity from "domain/main/MainEntity";

/**
 * [시스템] 팝업관리 Entity
 */
export default abstract class TbSysPopEntity extends MainEntity {
  @observable protected popNo: string = "";
  @observable protected popTitle: string = "";
  @observable protected stDate!: Date;
  @observable protected enDate!: Date;
  @observable protected linkUrl: string = "";
  @observable protected imgPath: string = "";
  @observable protected popHeight: number = 0;
  @observable protected popWidth: number = 0;
  @observable protected popTopPos: number = 0;
  @observable protected popLeftPos: number = 0;
  @observable protected fileId: string = "";
  @observable protected regUserid: string = "";
  @observable protected regDate!: Date;
  @observable protected modiUserid: string = "";
  @observable protected modiDate!: Date;

  public getPopNo() {
    return this.popNo;
  }

  @action
  public setPopNo(popNo: string): void {
    this.popNo = popNo;
  }

  public getPopTitle() {
    return this.popTitle;
  }

  @action
  public setPopTitle(popTitle: string): void {
    this.popTitle = popTitle;
  }

  public getStDate(): Date {
    return this.stDate;
  }

  @action
  public setStDate(stDate: Date): void {
    this.stDate = stDate;
  }

  public getEnDate(): Date {
    return this.enDate;
  }

  @action
  public setEnDate(enDate: Date): void {
    this.enDate = enDate;
  }

  public getLinkUrl() {
    return this.linkUrl;
  }

  @action
  public setLinkUrl(linkUrl: string): void {
    this.linkUrl = linkUrl;
  }

  public getImgPath() {
    return this.imgPath;
  }

  @action
  public setImgPath(imgPath: string): void {
    this.imgPath = imgPath;
  }

  public getPopHeight(): number {
    return this.popHeight;
  }

  @action
  public setPopHeight(popHeight: number): void {
    this.popHeight = popHeight;
  }

  public getPopWidth(): number {
    return this.popWidth;
  }

  @action
  public setPopWidth(popWidth: number): void {
    this.popWidth = popWidth;
  }

  public getPopTopPos(): number {
    return this.popTopPos;
  }

  @action
  public setPopTopPos(popTopPos: number): void {
    this.popTopPos = popTopPos;
  }

  public getPopLeftPos(): number {
    return this.popLeftPos;
  }

  @action
  public setPopLeftPos(popLeftPos: number): void {
    this.popLeftPos = popLeftPos;
  }

  public getFileId() {
    return this.fileId;
  }

  @action
  public setFileId(fileId: string): void {
    this.fileId = fileId;
  }

  public getRegUserid() {
    return this.regUserid;
  }

  @action
  public setRegUserid(regUserid: string): void {
    this.regUserid = regUserid;
  }

  public getRegDate(): Date {
    return this.regDate;
  }

  @action
  public setRegDate(regDate: Date): void {
    this.regDate = regDate;
  }

  public getModiUserid() {
    return this.modiUserid;
  }

  @action
  public setModiUserid(modiUserid: string): void {
    this.modiUserid = modiUserid;
  }

  public getModiDate(): Date {
    return this.modiDate;
  }

  @action
  public setModiDate(modiDate: Date): void {
    this.modiDate = modiDate;
  }
}
